// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
'use client';
import { FC, forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { register } from 'swiper/element/bundle';
import concatClassName from '@/helpers/concatClassName';

//import types
import { SwiperOptions } from 'swiper/types';

// register Swiper custom elements
register();

type SliderProps = {};

type RefType = {
    slides: any;
    className: string;
    initialSlide: number;
    // eslint-disable-next-line
    handleSlideChange: (index: number) => void;
    swiperContainerProps: SwiperOptions;
};

const Slider: FC<{}> = forwardRef<RefType, SliderProps>(
    ({ className, slides, initialSlide, handleSlideChange, swiperContainerProps }, ref) => {
        const swiperElRef = useRef(null);

        useImperativeHandle(ref, () => ({
            goToNextSlide: () => {
                swiperElRef.current.swiper.slideNext();
            },

            goToPreviousSlide: () => {
                swiperElRef.current.swiper.slidePrev();
            },

            onEndReach: (handleReachEnd) => {
                swiperElRef.current.swiper?.on('reachEnd', handleReachEnd);
            },

            setSlideIndex: (toGoSlideNumber) => {
                swiperElRef.current.swiper.slideTo(toGoSlideNumber);
            },

            swiperUpdate: () => {
                swiperElRef.current.swiper.updateSlides();
                swiperElRef.current.swiper.update();
            },

            onSliderMove: (handleSideNextTransitionEnd) => {
                swiperElRef.current?.swiper?.on('sliderMove', handleSideNextTransitionEnd);
            },

            offAnyEvents: () => {
                swiperElRef.current.swiper?.swiper?.offAny();
            }
        }));

        /* set required listeners */
        useEffect(() => {
            swiperElRef.current.addEventListener('slidechange', (event) => {
                handleSlideChange(event?.detail?.[0]?.activeIndex);
            });
        }, []);

        return (
            <div className={`slider-wrapper${concatClassName(className)}`} key="slider">
                <swiper-container
                    ref={swiperElRef}
                    initial-slide={initialSlide}
                    class="slider-container"
                    simulate-touch="false"
                    {...swiperContainerProps}>
                    {slides.map((slide, index) => (
                        <swiper-slide key={slide + index}>{slide}</swiper-slide>
                    ))}
                </swiper-container>
            </div>
        );
    }
);

Slider.displayName = 'Slider';

export default Slider;
